import React from 'react';
import { TPEReactTable, TPETableFooterRow } from 'src/components/shared/TPEReactTable';

/**
 * Reusable read-only grid for the Segment Data Tables feature, wrapping the shared `TPEReactTable`
 * (the same engine the CLI records grid uses). Both surfaces render through it: the list tab passes
 * its fixed columns + Name-link, and the detail data-viewer passes columns built from the table's own
 * `ColumnDef`s. Callers own their column definitions and row data; this only standardises the wrapper.
 */
export default function SegmentGrid(props: {
    columnDefinitions: any[];
    data: any[];
    className?: string;
    loading?: boolean;
    sortable?: boolean;
    onSortBy?: (e: Array<any>) => void;
    showFilters?: boolean;
    onFilter?: (e: Array<any>) => void;
    // Keep sort/filter state when `data` is replaced by a server re-fetch (manual sort/filter);
    // otherwise react-table's autoReset clears the state and fires an empty onSortBy/onFilter,
    // undoing the action the user just took.
    preserveStateOnDataChange?: boolean;
    emptyMessage?: string;
    // Pinned summary rows (period totals) rendered in the table's own tfoot so they stay column-aligned.
    footerRows?: TPETableFooterRow[];
}) {
    const {
        columnDefinitions,
        data = [],
        className = 'segmentGrid',
        loading = false,
        sortable = false,
        onSortBy,
        showFilters,
        onFilter,
        preserveStateOnDataChange,
        emptyMessage,
        footerRows,
    } = props;
    return (
        <TPEReactTable
            className={className}
            isSearching={loading}
            data={data}
            columnDefinitions={columnDefinitions}
            sortable={sortable}
            onSortBy={onSortBy}
            showFilters={showFilters}
            onFilter={onFilter}
            preserveStateOnDataChange={preserveStateOnDataChange}
            emptyMessage={emptyMessage}
            footerRows={footerRows}
        />
    );
}
